// This icon file is generated automatically.
var PUnorderedListOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M13.25 2H4.12a.13.13 0 00-.12.13V3c0 .07.06.13.13.13h9.12c.07 0 .13-.06.13-.13v-.88a.13.13 0 00-.13-.12zm0 4.44H4.12a.13.13 0 00-.12.12v.88c0 .07.06.12.13.12h9.12c.07 0 .13-.05.13-.12v-.88a.13.13 0 00-.13-.12zm0 4.43H4.12A.13.13 0 004 11v.88c0 .06.06.12.13.12h9.12c.07 0 .13-.06.13-.13V11a.13.13 0 00-.13-.13zM.62 2.57a.88.88 0 101.76 0 .88.88 0 00-1.75 0zM.63 7a.88.88 0 101.76 0A.88.88 0 00.63 7zm0 4.44a.87.87 0 101.75 0 .87.87 0 00-1.75 0z", "fill-rule": "nonzero" } }] }, "name": "p-unordered-list", "theme": "outlined" };
export default PUnorderedListOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PUnorderedListOutlined.js
// module id = 3702
// module chunks = 0